import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { SystemService } from 'app/Services/system.service';


type PrepareCatalogDetailsTabId = 'browse' | 'changed' | 'new' | 'deleted';

interface PrepareCatalogDetailsTabItem {
    id: PrepareCatalogDetailsTabId;
    title: string;
}

@Component({
    selector: 'np-prepare-catalog-details',
    templateUrl: './prepare-catalog-details.component.html',
    standalone: false,
    styleUrls: ['./prepare-catalog-details.component.css']
})
export class PrepareCatalogDetailsComponent implements OnInit {
    public readonly tabItems: PrepareCatalogDetailsTabItem[] = [
        { id: 'browse', title: this.translate.instant('Katalog') },
        { id: 'changed', title: this.translate.instant('Geänderte') },
        { id: 'new', title: this.translate.instant('Neue') },
        { id: 'deleted', title: this.translate.instant('Gelöschte') }
    ];

    public selectedTabId: PrepareCatalogDetailsTabId = 'browse';
    public selectedTabIndex = 0;

    public catalogTitle = '';

    public customerIdFromRoute: string | null = null;
    public catalogIdFromRoute: string | null = null;

    public constructor(
        private activatedRoute: ActivatedRoute,
        public systemService: SystemService,
        private catalogService: CatalogService,
        public translate: TranslateService,
        private router: Router
    ) {
    }

    public ngOnInit(): void {
        this.customerIdFromRoute = this.activatedRoute.snapshot.paramMap.get('customerId');
        this.catalogIdFromRoute = this.activatedRoute.snapshot.paramMap.get('catalogId');

        if (!this.customerIdFromRoute || !this.catalogIdFromRoute) {
            this.systemService.notifyWarning(
                this.translate.instant('Route Parameter customerId oder catalogId fehlen.')
            );
            this.router.navigate(['preparation/catalogs']);
            return;
        }

        this.catalogService.browseRoutePrefix = '/dataprocess/preparation/catalog';

        this.systemService.currentNavigationTitle = this.translate.instant('Katalog vorbereiten');

        this.catalogService
            .getCatalog(this.catalogIdFromRoute, this.customerIdFromRoute)
            .subscribe((catalog: any) => {
                this.catalogTitle = this.getCatalogTitleFromCatalog(catalog, this.catalogIdFromRoute!);
            });
    }

    public onTabSelectionChanged(event: { addedItems?: PrepareCatalogDetailsTabItem[] }): void {
        const tab = event?.addedItems?.[0];
        if (!tab) {
            return;
        }

        this.selectedTabId = tab.id;
        this.selectedTabIndex = this.tabItems.findIndex((x) => x.id === tab.id);

        this.catalogService.treeRefresh();
    }

    public get isBrowseTab(): boolean {
        return this.selectedTabId === 'browse';
    }

    public get additionalFilterForBrowseComponent(): string | null {
        switch (this.selectedTabId) {
            case 'changed':
                return 'CHANGED';
            case 'new':
                return 'NEU';
            case 'deleted':
                return 'DELETED';
            case 'browse':
            default:
                return null;
        }
    }

    public goBackToPrepareStage(): void {
        this.router.navigate(['/dataprocess/preparation']);
    }

    private getCatalogTitleFromCatalog(catalog: any, fallbackCatalogId: string): string {
        const title =
            catalog?.descriptionShort ??
            catalog?.catalogName ??
            catalog?.name ??
            catalog?.groupName ??
            catalog?.title;

        return title && String(title).trim().length > 0 ? String(title) : fallbackCatalogId;
    }
}
